import './bootstrap';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import ShowDetails from './pages/ShowDetails';
import SeatAllocation from './pages/SeatAllocation';
import Gananatya from './pages/Gananatya';
import GananatyaDetails from './pages/GananatyaDetails';
import Cart from './pages/Cart';
import MyTickets from './pages/MyTickets';
import Shows from './pages/Shows';
import Profile from './pages/Profile';
import Camps from './pages/Camps';
import Notifications from './pages/Notifications';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';

function App() {
  const path = window.location.pathname;
  let basename = '';
  const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
  if (isProduction) {
    if (path.startsWith('/react-app')) {
      basename = '/react-app';
    } else if (path.startsWith('/react/public')) {
      basename = '/react/public';
    } else if (path.startsWith('/react')) {
      basename = '/react';
    }
  } else {
    if (path.startsWith('/react-app')) {
      basename = '/react-app';
    }
  }

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="shows/:id" element={<ShowDetails />} />
          <Route path="shows/:id/seats" element={<SeatAllocation />} />
          <Route path="cart" element={<Cart />} />
          <Route path="shows" element={<Shows />} />
          <Route path="gananatya" element={<Gananatya />} />
          <Route path="gananatya/:id" element={<GananatyaDetails />} />
          <Route path="camps" element={<Camps />} />
          <Route path="tickets" element={<MyTickets />} />
          <Route path="my-tickets" element={<MyTickets />} />
          <Route path="profile" element={<Profile />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="term-condition" element={<TermsConditions />} />
          <Route path="mobile/term-condition" element={<TermsConditions />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="privacy_policy" element={<PrivacyPolicy />} />
          <Route path="mobile/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="actors" element={<Shows />} />
          <Route path="actors/:id" element={<Shows />} />
          <Route path="artists" element={<Shows />} />
          <Route path="artists/:id" element={<Shows />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
